import axios from '../services/axios';

// Push the visitor's consent state to Google Consent Mode v2 and the dataLayer
// so GTM (Google tags + the custom consent types we emit) reacts. Safe to call
// before gtag exists — the dataLayer push is always made.
export function applyConsentMode(consentMode) {
  if (!consentMode) { return; }

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', consentMode);
  }

  window.dataLayer.push({ event: 'consent_update', consent_mode: consentMode });
}

// Record a choice. `categories` is { advertising: bool, analytics: bool, ... };
// `source` tags where it was made (banner vs. settings center) for the
// accept-rate stats. axios injects the CSRF token from the page's csrf-token
// meta tag.
export function updateConsent(endpoint, categories, source) {
  return axios.put(endpoint, { ...categories, source }).then((response) => response.data);
}

// Tell the server the upfront banner was displayed (the denominator for
// accept/reject/ignore rates — deduped per visitor server-side). Fire and
// forget: measurement must never affect the banner itself.
export function logImpression(endpoint) {
  return axios.post(`${endpoint}/impression`).catch(() => {});
}
